import React from "react";
import Image from "next/image";
import {AspectRatio, Box} from "@chakra-ui/react";
import IntroLayout from "@/components/introLayout";
import {INTRODUCTION_CONSTANTS} from "../cloudApplication.constant";

const Introduction = () => {
  return (
    <IntroLayout
      content={[INTRODUCTION_CONSTANTS.CONTENT]}
      heading={[INTRODUCTION_CONSTANTS.HEADING]}
      subHeading={INTRODUCTION_CONSTANTS.SERVICE}
      image={<ImageElement />}
    />
  );
};

export default Introduction;

const ImageElement = () => {
  return (
    <Box alignSelf={{sm: "center"}} bg={"#F5F5F5"} borderRadius="full" p={4}>
      <AspectRatio
        position={"relative"}
        ratio={1}
        transition={"all 0.3s ease"}
        width={{base: "full", sm: "400px", md: "500px"}}
        _hover={{transform: "scale(1.08)"}}
      >
        <Image
          alt="Cloud-Application"
          fill
          src={"/cloud-application/cloud-application.jpg"}
          style={{borderRadius: "50%", objectFit: "contain", objectPosition: "top"}}
        />
      </AspectRatio>
    </Box>
  );
};
